window.onload = function(){
  var linkmsg=document.getElementById("linkmsg");
  linkmsg.style.visibility="hidden";
  sizemsg.style.visibility="hidden";
  document.getElementById("material").innerHTML = "選択してください";
  document.getElementById("width").value="";
  document.getElementById("depth").value="";
  document.getElementById("height").value="";
  document.getElementById("price").value="";
  var cancel = document.querySelectorAll(`input[type='radio'][name='color_main']`);
  for (const i of cancel) {i.checked = false;}
  var cancel2 = document.querySelectorAll(`input[type='checkbox']`);
  for (const i of cancel2) {i.checked = false;}
  cartReset();resizing();
}
window.onresize = function(){resizing();}

//リサイズ
function resizing(){
 var size_acquisition = document.getElementById("size_img");
 var wsize = size_acquisition.clientWidth;
 $("#size_img img").css("width",wsize+"px");
 var size_acquisition = document.getElementById("demoimg");
 var hsize = size_acquisition.clientHeight;
 $("#size_img").css("height",hsize+"px");
}

//カート中身リセット
function cartReset(){
    document.getElementById("price").value=""
    cart_price.innerHTML =""+" 円";
    cart_width.innerHTML=""; 
    cart_depth.innerHTML=""; 
    cart_height.innerHTML="";
    cart_color.innerHTML="";
    linkmsg.style.visibility="hidden";
}

//リアルタイムサイズチェック
function changeMsg(){
    var intDepth=document.getElementById("depth").value;
    var intWidth=document.getElementById("width").value;
    var intHeight=document.getElementById("height").value;
    sizemsg.style.visibility="hidden";
    cartReset();
    if (intDepth==""||intWidth==""||intHeight==""){
        document.getElementById("sizemsg").innerHTML = "<p> </p>";
     sizemsg.style.visibility="hidden";
        return false;
    }
    if (intWidth < 45 || intWidth > 120){document.getElementById("sizemsg").innerHTML = "<p>※ 幅45cm未満・幅121cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    if (intDepth < 24 || intDepth > 35){document.getElementById("sizemsg").innerHTML = "<p>※ 奥行24cm未満・奥行36cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    if (intHeight < 8 || intHeight > 15){document.getElementById("sizemsg").innerHTML = "<p>※ 高さ8cm未満・高さ16cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    document.getElementById("sizemsg").innerHTML = "<p> </p>"
    
 sizemsg.style.visibility="hidden";
}

//材質切替 <br class=\"delete\">
function materialWood(){document.getElementById("material").innerHTML = "リーズナブル木目：<br>[材質]プリント化粧合板";}
function materialAino(){document.getElementById("material").innerHTML = "パステルカラーaino：<br>[材質]強化紙化粧合板";}
function materialMela(){document.getElementById("material").innerHTML = "ハイグレード鏡面仕上げ：<br>[材質]メラミン樹脂化粧合板(アイカ工業製)";}




//サイズオーダー
const strLink1="<a href=\"https://interior-arne.com/products/"
const strLink2="\" target=\"_blank\">→こちらのページよりお買い求めください。</a>"

function setGoods(url,width,depth,height,color){
this.url=url;this.width=width;this.depth=depth;this.height=height;this.color=color;}

function searchURL(strWidth,strDepth,strHeight,strColor){
  var strErr;
  var intWidth=document.getElementById("width").value
  var intDepth=document.getElementById("depth").value
  var intHeight=document.getElementById("height").value

  //サイズチェック
  if (intWidth < 45 || intWidth > 120){strErr="幅45cm未満・幅121cm以上は";}
  else if (intDepth < 24 || intDepth > 35){strErr="奥行24cm未満・奥行36cm以上は";}
  else if (intHeight < 8 || intHeight > 15){strErr="高さ8cm未満・高さ16cm以上は";}
  if(strErr){document.getElementById("price").value="";
  return strErr+"オーダー不可です。";}

  //幅サイズ成形
  switch(intWidth != null){
    case intWidth <= 45: priceW = 0;break;
    case intWidth <= 50: priceW = 1;break;
    case intWidth <= 60: priceW = 2;break;
    case intWidth <= 70: priceW = 3;break;
    case intWidth <= 80: priceW = 4;break;
    case intWidth <= 90: priceW = 5;break;
    case intWidth <= 100: priceW = 6;break;
    case intWidth <= 110: priceW = 7;break;
    case intWidth <= 120: priceW = 8;break;
  }

  //高さサイズ成形
  switch(intHeight != null){
    case intHeight <= 10: priceH = 0;break;
    case intHeight <= 15: priceH = 3;break;
  }

  //奥行サイズ成形
  switch(intDepth != null){
    case intDepth <= 25: priceD = 0;break;
    case intDepth <= 30: priceD = 1;break;
    case intDepth <= 35: priceD = 2;break;
  }
  
    var arr = csvToArray("https://cdn.shopify.com/s/files/1/0549/1834/8887/files/sps-ms_price.csv?v=1689831620");
    priceD = priceD+priceH;
    if(strColor == "nail" || strColor == "black" || strColor == "bp"){priceW=priceW+9;}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){priceW=priceW+18;}
    var sellPrice = arr[priceD][priceW];
    return sellPrice;

  function csvToArray(filename) {

    var srt = new XMLHttpRequest();
    srt.open("GET", filename, false);
    try {
      srt.send(null);
    } catch (err) {
      console.log(err)
    }
    var csvArr = [];
    var lines = srt.responseText.split("\n");
    for (var i = 0; i < lines.length; ++i) {
      var cells = lines[i].split(",");
      if (cells.length != 1) {
        csvArr.push(cells);
      }
    }
    return csvArr;
  }
  
}


//サイズ入力時
function changeSize(){
  var intWidth=document.getElementById("width").value
  var intDepth=document.getElementById("depth").value
  var intHeight=document.getElementById("height").value
  var imgW = "45";
  var imgD = "24";
  var imgH = "8";
  switch(imgW != null){
    case intWidth == "": imgD = "120";break;
    case intWidth <= 70: imgW = "45";break;
    case intWidth <= 100: imgW = "70";break;
    case intWidth <= 120: imgW = "100";break;
    default:imgW = "45";
  }
  switch(imgD != null){
    case intDepth == "": imgD = "24";break;
    case intDepth <= 30: imgD = "24";break;
    case intDepth <= 35: imgD = "30";break;
    default:imgD = "24";
  }
  switch(imgH != null){
    case intHeight == "": imgH = "8";break;
    case intHeight <= 11: imgH = "8";break;
    case intHeight <= 15: imgH = "12";break;
    default:imgH = "8";
  }
  var changeSize = imgW+imgD+imgH;
  var changeImgUrl = $(document.area1).attr("src").split("/");
  var changeImgUrl = $(document.area1).attr("src").replace(changeImgUrl[10] , changeSize);
  $(document.area1).attr("src", changeImgUrl+".png");
  $("#size_img img:nth-of-type(3)").css("display","none");
}

function colorMain(changeImg){
  var colorList = document.getElementsByName("color_main");
  if(changeImg<=13){var chooseColor=colorList[changeImg].id.slice(5);}
  else {var chooseColor=colorList[changeImg].id}

  let imgColor = $(document.area1).attr("src").split("/");
  imgColor = $(document.area1).attr("src").replace(imgColor[9] , chooseColor+"_color");
  $(document.area1).attr('src', imgColor);
}


/*リストから商品URLを取得*/
function checkURL(strWidth,strDepth,strHeight,strColor){
switch(true){
 default:
  for(var i in goods){
if(goods[i].width==strWidth && goods[i].depth==strDepth && goods[i].height==strHeight && goods[i].color==strColor){
return goods[i].url;}}
  break;
return false;
}
}
// 数値チェック
function isNumber(numVal){
  var pattern =/^([1-9]\d*|0)$/;
  return pattern.test(numVal);
}
/*価格算出ボタン押下時*/
function jump(){
cartReset();
    
var linkmsg=document.getElementById("linkmsg");
linkmsg.innerHTML="";
linkmsg.style.visibility="hidden";
var ErrMsg=document.getElementById("linkmsg");
ErrMsg.innerHTML="";
document.getElementById("price").value=""

var strDepth=document.getElementById("depth").value;
var strWidth=document.getElementById("width").value;
var strHeight=document.getElementById("height").value;
var idColor = document.getElementsByName("color_main") ;
var strColor = "";
var i=0;
var c=0;
for ( strColor="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
     if( idColor[i].id.slice(0,4)=="wood" ){
         strColor = idColor[i].id.slice(0,4);
     }else if( idColor[i].id.slice(0,4)=="aino" ){
         strColor = idColor[i].id.slice(0,4);
     }else{
         strColor = idColor[i].id;
     }
  var valueColor = idColor[i].value ;
  break ;
 }
}



if (isNumber(strWidth)==false){
alert("幅は『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}
if (isNumber(strDepth)==false){
alert("奥行は『1以上の整数(小数点不可/半角文字）』をご入力ください");
return false;
}
if (isNumber(strHeight)==false){
alert("高さは『1以上の整数(小数点不可/半角文字）』をご入力ください");
return false;
}
if (strColor==false){
alert("カラーを選択してください");
return false;
}


document.getElementById("choice1").value=strWidth+"cm";
document.getElementById("choice2").value=strDepth+"cm";
document.getElementById("choice3").value=strHeight+"cm";
document.getElementById("choice4").value=valueColor+"";
//商品ページの有無チェック
var comcode=checkURL(strWidth,strDepth,strHeight,strColor);
if (!comcode==""){
  var target=document.getElementById("linkmsg");
  linkmsg.style.visibility="visible";
  target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
  return false;
}
var url=searchURL(strWidth,strDepth,strHeight,strColor);

if(!url){
alert("幅、奥行、高さを選んでください");
return false;
}


var intUnit;
if (isNaN(url)==false){
 intUnit=(parseInt(url))/100;
 document.getElementById("price").value =(parseInt(url)).toLocaleString()+" 円";
 cart_price.innerHTML =(parseInt(url)).toLocaleString()+" 円";
 cart_width.innerHTML=strWidth;
 cart_depth.innerHTML=strDepth;
 cart_height.innerHTML=strHeight;
 cart_color.innerHTML=valueColor;
}
else if(isNaN(url)==true) {
linkmsg.style.visibility="visible";
 ErrMsg.innerHTML=url;
 intUnit=""
}
document.getElementById("units").value=intUnit;
document.getElementById("choice6").value="見積もり金額："+(parseInt(url));
return false;
}



function checkText() {
 var choice1=document.frm.choice1.value;
 var choice2=document.frm.choice2.value;
 var choice3=document.frm.choice3.value;
 var choice4=document.frm.choice4.value;
 var choice6=document.frm.choice6.value;
 var text = document.frm.inventory_id.value;
 var price = document.frm_detail.price.value;
 if(choice1=="" || choice2=="" || choice3=="") {
     alert("ご希望のサイズを正しく入力後、価格算出ボタンを押してください。");
     return false;
 }
 if(price=="") {
     alert("価格が算出されていません。既製品がある場合、「この条件で金額算出」ボタン下の該当商品ページよりお買い求めください。");
     return false;
 }       
 return true;
}



goods = new Object();
goods[0] =new setGoods("0000ae019816","45","24","8","wood");
goods[1] =new setGoods("0000ae019817","45","24","8","wood");
goods[2] =new setGoods("0000ae019818","45","24","8","wood");
goods[3] =new setGoods("0000ae019819","45","24","8","wood");
goods[4] =new setGoods("0000ae019820","45","24","8","wood");
goods[5] =new setGoods("0000ae019821","45","24","8","wood");
goods[6] =new setGoods("0000ae019822","45","24","8","wood");
goods[7] =new setGoods("0000ae019823","45","24","8","wood");
goods[8] =new setGoods("0000ae019824","55","24","8","wood");
goods[9] =new setGoods("0000ae019825","55","24","8","wood");
goods[10] =new setGoods("0000ae019826","55","24","8","wood");
goods[11] =new setGoods("0000ae019827","55","24","8","wood");
goods[12] =new setGoods("0000ae019828","55","24","8","wood");
goods[13] =new setGoods("0000ae019829","55","24","8","wood");
goods[14] =new setGoods("0000ae019830","55","24","8","wood");
goods[15] =new setGoods("0000ae019831","55","24","8","wood");
goods[16] =new setGoods("0000ae019832","45","24","8","aino");
goods[17] =new setGoods("0000ae019833","45","24","8","aino");
goods[18] =new setGoods("0000ae019834","45","24","8","aino");
goods[19] =new setGoods("0000ae019835","45","24","8","aino");
goods[20] =new setGoods("0000ae019836","45","24","8","aino");
goods[21] =new setGoods("0000ae019837","45","24","8","aino");
goods[22] =new setGoods("0000ae019838","55","24","8","aino");
goods[23] =new setGoods("0000ae019839","55","24","8","aino");
goods[24] =new setGoods("0000ae019840","55","24","8","aino");
goods[25] =new setGoods("0000ae019841","55","24","8","aino");
goods[26] =new setGoods("0000ae019842","55","24","8","aino");
goods[27] =new setGoods("0000ae019843","55","24","8","aino");
goods[28] =new setGoods("0000ae019844","45","24","8","nail");
goods[29] =new setGoods("0000ae019845","45","24","8","black");
goods[30] =new setGoods("0000ae019846","45","24","8","bp");
goods[31] =new setGoods("0000ae019847","45","24","8","mb");
goods[32] =new setGoods("0000ae019848","45","24","8","gs");
goods[33] =new setGoods("0000ae019849","45","24","8","ww");
goods[34] =new setGoods("0000ae019850","55","24","8","nail");
goods[35] =new setGoods("0000ae019851","55","24","8","black");
goods[36] =new setGoods("0000ae019852","55","24","8","bp");
goods[37] =new setGoods("0000ae019853","55","24","8","mb");
goods[38] =new setGoods("0000ae019854","55","24","8","gs");
goods[39] =new setGoods("0000ae019855","55","24","8","ww");


